export default __webpack_public_path__ + "static/media/Slide-1.0844824b.png";